"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CapabilityStatement_SearchParam = exports.CapabilityStatement_SearchParamTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var CapabilityStatement_SearchParamTypeKind;
(function (CapabilityStatement_SearchParamTypeKind) {
    CapabilityStatement_SearchParamTypeKind["_number"] = "number";
    CapabilityStatement_SearchParamTypeKind["_date"] = "date";
    CapabilityStatement_SearchParamTypeKind["_string"] = "string";
    CapabilityStatement_SearchParamTypeKind["_token"] = "token";
    CapabilityStatement_SearchParamTypeKind["_reference"] = "reference";
    CapabilityStatement_SearchParamTypeKind["_composite"] = "composite";
    CapabilityStatement_SearchParamTypeKind["_quantity"] = "quantity";
    CapabilityStatement_SearchParamTypeKind["_uri"] = "uri";
    CapabilityStatement_SearchParamTypeKind["_special"] = "special";
})(CapabilityStatement_SearchParamTypeKind = exports.CapabilityStatement_SearchParamTypeKind || (exports.CapabilityStatement_SearchParamTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_CapabilityStatement_SearchParam = t.recursion('ICapabilityStatement_SearchParam', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        name: t.string,
        _name: RTTI_Element_1.RTTI_Element,
        definition: RTTI_canonical_1.RTTI_canonical,
        type: (0, EnumType_1.createEnumType)(CapabilityStatement_SearchParamTypeKind, 'CapabilityStatement_SearchParamTypeKind'),
        _type: RTTI_Element_1.RTTI_Element,
        documentation: RTTI_markdown_1.RTTI_markdown,
        _documentation: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_CapabilityStatement_SearchParam.js.map